/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import * as Func from "services/Function";
import { useSelector } from "react-redux";

// Anaytics dashboard components
import TimelineList from "examples/Timeline/TimelineList";
import TimelineItem from "examples/Timeline/TimelineItem";

// Navbar
import Navbar from "examples/Navbars/NavBar";

const initChart = {
  title: "",
  description: "",
  date: "",
  chart: {
    labels: [],
    datasets: { label: "", data: [] },
  },
};

function DashboardAdmin() {
  const mod = "dashboard_admin";
  const { t, i18n } = useTranslation();
  const app = useSelector((state) => state[APP_STATE]);
  const [log, setLog] = useState([]);
  const [stockFG, setStockFG] = useState([]);
  const [stockRM, setStockRM] = useState([]);
  const [chartSale, setChartSale] = useState(initChart);
  const [chartInvoice, setChartInvoice] = useState(initChart);
  const [chartTask, setChartTask] = useState(initChart);
  const [stat, setStat] = useState({
    stat1: { count: "", color: "white", amount: "", label: "" },
    stat2: { count: "", color: "white", amount: "", label: "" },
    stat3: { count: "", color: "white", amount: "", label: "" },
    stat4: { count: "", color: "white", amount: "", label: "" },
    stat5: { count: "", color: "white", amount: "", label: "" },
    stat6: { count: "", color: "white", amount: "", label: "" },
  });

  const init = () => {
    FetchData("GET", `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === "ok") {
        setChartSale(result.sale);
        setChartInvoice(result.invoice);
        setChartTask(result.task);
        setStat(result.stat);
        setStockFG(result.fg);
        setStockRM(result.rawmat);
        setLog(result.log);
      } else {
        Func.exitApp();
      }
    });
  };

  const setBtnBadge = (name, value, link) => {
    return (
      <Grid item xs={12} md={6} lg={2}>
        <MDButton variant="gradient" color="info" href={link} fullWidth>
          <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", gap: 1 }}>
            {name}
            <MDBadge badgeContent={value} color="error" container size="xs" />
          </Box>
        </MDButton>
      </Grid>
    );
  };

  const renderStat = () => {
    return (
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="paid"
                title="ยอดขาย"
                count={stat.stat1.count}
                percentage={{
                  color: stat.stat1.color,
                  amount: stat.stat1.amount,
                  label: stat.stat1.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="weekend"
                title="ลูกค้า"
                count={stat.stat2.count}
                percentage={{
                  color: stat.stat2.color,
                  amount: stat.stat2.amount,
                  label: stat.stat2.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="การผลิต"
                count={stat.stat3.count}
                percentage={{
                  color: stat.stat3.color,
                  amount: stat.stat3.amount,
                  label: stat.stat3.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                title="จัดซื้อ"
                count={stat.stat4.count}
                percentage={{
                  color: stat.stat4.color,
                  amount: stat.stat4.amount,
                  label: stat.stat4.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="ค่าใช้จ่าย"
                count={stat.stat5.count}
                percentage={{
                  color: stat.stat5.color,
                  amount: stat.stat5.amount,
                  label: stat.stat5.label,
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="point_of_sale"
                title="ค้างชำระ"
                count={stat.stat6.count}
                percentage={{
                  color: stat.stat6.color,
                  amount: stat.stat6.amount,
                  label: stat.stat6.label,
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderButton = () => {
    return (
      <MDBox mt={3}>
        <Grid container spacing={3}>
          {setBtnBadge(t(`menu.quotation`), app.badge.quotation, "/quotation")}
          {setBtnBadge(t(`menu.invoice`), app.badge.invoice, "/invoice")}
          {setBtnBadge(t(`menu.job_order`), app.badge.job_order, "/job_order")}
          {setBtnBadge(t(`menu.purchase_request`), app.badge.purchase_request, "/purchase_request")}
          {setBtnBadge(t(`menu.purchase_order`), app.badge.purchase_order, "/purchase_order")}
          {setBtnBadge(t(`menu.receive`), app.badge.receive, "/receive")}
        </Grid>
      </MDBox>
    );
  };

  const renderChart = () => {
    return (
      <MDBox mt={6}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsBarChart
                color="info"
                title="ยอดขายต่อวัน"
                description={chartTask.description}
                date={chartSale.date}
                chart={chartSale.chart}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsLineChart
                color="success"
                title="ยอดขายต่อเดือน"
                description={chartInvoice.description}
                date={chartInvoice.date}
                chart={chartInvoice.chart}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsLineChart
                color="dark"
                title="ยอดขายต่อเดือน"
                description={chartTask.description}
                date={chartTask.date}
                chart={chartTask.chart}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderTimeline = () => {
    return (
      <MDBox mt={0}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <TimelineList title="การใช้งานระบบ">
              {log.map((item) => (
                <TimelineItem
                  key={item.id}
                  color={item.color}
                  icon={item.icon}
                  title={t(`entity.${item.title}`)}
                  dateTime={Func.dateTimeDisplay(item.dateTime)}
                  description={`ผู้ทำรายการ : ${item.description}`}
                  badges={item.badges}
                  lastItem={item.lastItem}
                />
              ))}
            </TimelineList>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TimelineList title="ความเคลื่อนไหวคลังสินค้า">
              {stockFG.map((item) => (
                <TimelineItem
                  key={item.id}
                  color={item.color}
                  icon={item.icon}
                  title={item.title}
                  dateTime={Func.dateTimeDisplay(item.dateTime)}
                  description={item.description}
                  badges={item.badges}
                  lastItem={item.lastItem}
                />
              ))}
            </TimelineList>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TimelineList title="ความเคลื่อนไหวคลังวัตถุดิบ">
              {stockRM.map((item) => (
                <TimelineItem
                  key={item.id}
                  color={item.color}
                  icon={item.icon}
                  title={item.title}
                  dateTime={Func.dateTimeDisplay(item.dateTime)}
                  description={item.description}
                  badges={item.badges}
                  lastItem={item.lastItem}
                />
              ))}
            </TimelineList>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, []);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.dashboard`), t(`menu.dashboard_admin`)]} />
      <MDBox py={3}>
        {renderStat()}
        {renderButton()}
        {renderChart()}
        {renderTimeline()}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardAdmin;
